module.exports = __webpack_public_path__ + "img/helpcenter.ne.4bf95688.svg";